module.exports = __webpack_public_path__ + "img/password-reset-confirmation.b70275ad.svg";